(function () {

  function sortSellers() {
    const scores = window.bcircleSellerScores || {};
    const sortMode = window.bcircleSortMode || 'relevance';
    const container = document.querySelector('.all_seller');
    if (!container) return;

    const cards = Array.from(container.querySelectorAll('.mp-seller-grid.sellers'));
    if (cards.length === 0) return;

    cards.sort((a, b) => {
      const idA = a.id.replace('seller_', '');
      const idB = b.id.replace('seller_', '');
      const scoreA = scores[idA]?.[sortMode] || 0;
      const scoreB = scores[idB]?.[sortMode] || 0;
      return scoreB - scoreA;
    });

    cards.forEach(card => container.appendChild(card));
  }

  function waitAndSort() {
    const observer = new MutationObserver((mutations, obs) => {
      const container = document.querySelector('.all_seller');
      const cards = container?.querySelectorAll('.mp-seller-grid.sellers');
      if (cards && cards.length > 0) {
        obs.disconnect();
        setTimeout(sortSellers, 300);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitAndSort);
  } else {
    waitAndSort();
  }

})();